import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import {
  createTreeSpecies,
  deleteTreeSpecies,
  fetchAllTreeSpecies,
  updateTreeSpecies,
  type TreeSpeciesPatch,
} from '../../api/tree-species';

/** Shared with the species pickers, so a change here refreshes them too. */
const TREE_SPECIES_KEY = ['tree-species'];

export function useTreeSpecies() {
  const qc = useQueryClient();
  const refresh = () => qc.invalidateQueries({ queryKey: TREE_SPECIES_KEY });

  const list = useQuery({ queryKey: [...TREE_SPECIES_KEY, 'all'], queryFn: fetchAllTreeSpecies });

  // Settle (not just succeed) so a 404 for a species someone else deleted
  // drops it from the list.
  const create = useMutation({ mutationFn: createTreeSpecies, onSettled: refresh });
  const update = useMutation({
    mutationFn: ({ id, patch }: { id: string; patch: TreeSpeciesPatch }) =>
      updateTreeSpecies(id, patch),
    onSettled: refresh,
  });
  const remove = useMutation({ mutationFn: deleteTreeSpecies, onSettled: refresh });

  return { list, create, update, remove };
}
